import React from "react";
import { useNavigate } from "react-router-dom";
// const url = "http://localhost:8000";
const url = process.env.REACT_APP_BACKEND_URL;

function DoctorCard({ doctor }) {
  const navigate = useNavigate();
  return (
    <div
      className="card cursor-pointer"
      onClick={() => navigate(`${url}/book-appointment/${doctor._id}`)}
    >
      <h1 className="card-title">
        {doctor.firstName} {doctor.lastName}
      </h1>
      {/* <hr /> */}
      <p>
        <b>Phone Number : </b>
        {doctor.phoneNumber}
      </p>
      <p>
        <b>Address : </b>
        {doctor.address}
      </p>
      <p>
        <b>Specialization : </b>
        {doctor.specialization}
      </p>
      <p>
        <b>Fee per Visit : </b>
        {doctor.feePerConsultation}
      </p>
      <p>
        <b>Timings : </b>
        {doctor.timings[0]} - {doctor.timings[1]}
      </p>
    </div>
  );
}

export default DoctorCard;